import { Link } from 'react-router-dom'
import '../common.less'
import './home.less'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import homePro1 from 'image/home-pro1.png'
import homePro2 from 'image/home-pro2.png'
import homePro3 from 'image/home-pro3.png'
import homePro4 from 'image/home-pro4.png'
import brandLogo from 'image/brand-logo.png'
// import ScrollAnim from 'rc-scroll-anim'
import { useEffect, useState } from 'react'
import { post } from 'request/request'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { selectLocale } from 'store/localeSlice'


// const ScrollOverPack = ScrollAnim.OverPack
export const Home = () => {
	const [screenWidth,setScreenWidth] = useState(document.body.clientWidth);
	const [pageBlockWidth,setPageBlockWidth] = useState(screenWidth > 1220 ? 1220 : screenWidth);
	const [targetDom1, setTargetDom1] = useState<HTMLVideoElement>()
	const [targetDom2, setTargetDom2] = useState<HTMLVideoElement>()
	const [targetDom3, setTargetDom3] = useState<HTMLVideoElement>()
	const [newsList, setNewsList] = useState([])
	const intl = useIntl();
	const locale= useSelector(selectLocale);
	const [curProductor, setCurProductor] = useState('/Product')

	const [newsLinkClass, setNewsLinkClass] = useState('link-btn')
	const [curNews, setCurNews] = useState(-1)

	window.onresize = function () {
		setScreenWidth(document.body.clientWidth);
	}
	useEffect(() => {
       if(targetDom1){
		   targetDom1.play()
	   }
    }, [targetDom1])
	useEffect(() => {
		if(targetDom2){
			targetDom2.play()
		}
	 }, [targetDom2])
	 useEffect(() => {
		if(targetDom3){
			targetDom3.play()
		}
	 }, [targetDom3])
	useEffect( ()=>{setPageBlockWidth(screenWidth > 1220 ? 1220 : screenWidth);}, [screenWidth])
	const DownanimConfig = [
		{ opacity: [1, 0], translateY: [0, 50] },
		{ opacity: [1, 0], translateY: [0, 50] }
	];
	const settings = {
        // dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
		autoplaySpeed: 8000,
        slidesToShow: 1,
        slidesToScroll: 1,
		afterChange: (index: any) => {
			setCurProductor(index==1 ? '/ProductR1' : index==2 ? '/ProductM1' : '/Product')
		}
    };
	
    
    useEffect(() => {
        post('snailcar/website/common/queryNews',{pageNo: 1,pageSize: 2}, {headers: {language: locale}}).then((data:any) => {
            if (data.resultCode === '200' ){
                setNewsList(data.resultBody.data.list)
            }
        })
    }, [])
	return <div className="scar-home">
		<div className="banner-video">
			{/* <Slider {...settings}> */}
				<video ref={(dom:HTMLVideoElement) => { setTargetDom1(dom) }} autoPlay={true} playsInline webkit-playsinline="true"  loop={true} preload={'true'} muted poster={locale === 'ko' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17007226091339267.png' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17007225883718727.png'}>
					<source type="video/mp4" src={locale === 'ko' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/16814370146519926.mp4' : "https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/official/course/16697990185702632.mp4"}></source>
				</video>
				{/* <video ref={(dom:HTMLVideoElement) => { setTargetDom2(dom) }} autoPlay={true} playsInline webkit-playsinline="true"  loop={true} preload={'true'} muted poster={'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17007226274251774.png'}>
					<source type="video/mp4" src={"https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/businessFile/17005529139733625.m4v"}></source>
				</video>
				<video ref={(dom:HTMLVideoElement) => { setTargetDom3(dom) }} autoPlay={true} playsInline webkit-playsinline="true"  loop={true} preload={'true'} muted poster={'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17007227671771183.png'}>
					<source type="video/mp4" src={'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/businessFile/17005531792418255.m4v'}></source>
				</video>
			</Slider>  */}
				{/* <img style={{width: '100%'}} src="https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17029724010867971.jpg" alt="" /> */}
				<div className="banner-video-wrapper">
					<div className="banner-title font-75">{intl.formatMessage({id: 'home.video.title'})}</div>
					<Link className="snc-btn font-20" to={curProductor}>{intl.formatMessage({id: 'home.video.btn'})}</Link>
				</div>
			</div>
		{/* <Slider {...settings}>
			<div className="banner-video">
				<video ref={(dom:HTMLVideoElement) => { setTargetDom1(dom) }} autoPlay={true} playsInline webkit-playsinline="true"  loop={true} preload={'true'} muted poster={locale === 'ko' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17007226091339267.png' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17007225883718727.png'}>
					<source type="video/mp4" src={locale === 'ko' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/16814370146519926.mp4' : "https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/official/course/16697990185702632.mp4"}></source>
				</video>
				<div className="banner-video-wrapper">
					<div className="banner-title font-75">{intl.formatMessage({id: 'home.video.title'})}</div>
					<Link className="snc-btn font-20" to='/Product'>{intl.formatMessage({id: 'home.video.btn'})}</Link>
				</div>
			</div>
			<div className="banner-video">
				<video ref={(dom:HTMLVideoElement) => { setTargetDom2(dom) }} autoPlay={true} playsInline webkit-playsinline="true"  loop={true} preload={'true'} muted poster={'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17007226274251774.png'}>
					<source type="video/mp4" src={"https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/businessFile/17005529139733625.m4v"}></source>
				</video>
				<div className="banner-video-wrapper">
					<div className="banner-title font-75">{intl.formatMessage({id: 'home.video.title'})}</div>
					<Link className="snc-btn font-20" to='/ProductR1'>{intl.formatMessage({id: 'home.video.btn'})}</Link>
				</div>
			</div>
			<div className="banner-video">
				<video ref={(dom:HTMLVideoElement) => { setTargetDom3(dom) }} autoPlay={true} playsInline webkit-playsinline="true"  loop={true} preload={'true'} muted poster={'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17007227671771183.png'}>
					<source type="video/mp4" src={'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/businessFile/17005531792418255.m4v'}></source>
				</video>
				<div className="banner-video-wrapper">
					<div className="banner-title font-75">{intl.formatMessage({id: 'home.video.title'})}</div>
					<Link className="snc-btn font-20" to='/ProductM1'>{intl.formatMessage({id: 'home.video.btn'})}</Link>
				</div>
			</div>
		</Slider> */}
		{/* <div className='home-banner-wrapper'>
			<div className='home-banner-containner'>
				<img src={proS1} alt="" />
				<div className='home-banner-title'>{intl.formatMessage({id: 'home.video.title'})}</div>
				<Link className='learn-more' to={'/Product'}><span>{intl.formatMessage({id: 'home.pro.learnMore'})}</span><RightOutlined /></Link>
			</div>
			<Link className='home-banner-link' to={'/Product'}/>
		</div> */}
		<div className='scar-join-us font-20'>
			<span>{intl.formatMessage({id: 'home.join.title'})}</span>
			<Link className='join-link' to="/BecomeADistributor">{intl.formatMessage({id: 'home.join.btn'})}</Link>
		</div>
		<div className='scar-pro-wrapper'>
			<div 
				style={{minHeight:  pageBlockWidth > 751 ? (540*pageBlockWidth)/1220+'px' : (270*pageBlockWidth)/1220+'px'}}>
				<div className='pro-flex-item'>
					<div className='flex-img'><img src={homePro1} alt="" /></div>
					<div className='flex-content'>
						<div >
							<p className='title'>{intl.formatMessage({id: 'home.pro.title1'})}</p>
							<p className='content'>{intl.formatMessage({id: 'home.pro.con1'})}</p>
							<div className='flex-end'><Link  className='more-btn' to='/Product'>{intl.formatMessage({id: 'home.pro.btn'})}</Link></div>
						</div>
					</div>
				</div>	
			</div>
		</div>
		<div style={{background: 'rgba(180,180,180,.1)',width: '100%'}}>
			<div 
				className='scar-pro-wrapper'
				style={{minHeight:  pageBlockWidth > 751 ? (540*pageBlockWidth)/1220+'px' : (270*pageBlockWidth)/1220+'px'}}>
				<div className='pro-flex-item'>
					<div className='flex-img block-750'><img src={homePro2} alt="" /></div>
					<div  className='flex-content'>
						<div >
							<p  className='title'>{intl.formatMessage({id: 'home.pro.title2'})}</p>
							<p className='content'>{intl.formatMessage({id: 'home.pro.con2'})}</p>
							<div className='flex-end'><Link  className='more-btn' to='/ProductR1'>{intl.formatMessage({id: 'home.pro.btn'})}</Link></div>
						</div>
					</div>
					<div  className='flex-img block-750-hiddle'><img src={homePro2} alt="" /></div>
				</div>	
			</div>
		</div>
		<div className='scar-pro-wrapper'>
			<div 
				style={{minHeight: pageBlockWidth > 751 ? (540*pageBlockWidth)/1220+'px' : (270*pageBlockWidth)/1220+'px'}}>
				<div className='pro-flex-item'>
					<div  className='flex-img'><img src={homePro3} alt="" /></div>
					<div  className='flex-content'>
						<div >
							<p  className='title'>{intl.formatMessage({id: 'home.pro.title3'})}</p>
							<p className='content'>{intl.formatMessage({id: 'home.pro.con3'})}</p>
							<div className='flex-end'><Link  className='more-btn' to='/ProductM1'>{intl.formatMessage({id: 'home.pro.btn'})}</Link></div>
						</div>
					</div>
				</div>	
			</div>
		</div>
		
		<div 
			style={{minHeight: (869*pageBlockWidth)/1920+'px'}}
			className='home-app-wrapper'>
			<div  className='app-content block-750-hiddle'>
				<p  className='title'>{intl.formatMessage({id: 'home.app.title'})}</p>
				<p  className='content'>{intl.formatMessage({id: 'home.app.con'})}</p>
				<Link  className='more-btn' to='/InstallationVideo/app'>{intl.formatMessage({id: 'home.app.btn'})}</Link>
			</div>
			<div>
				<img className='pc-block' src={homePro4} alt="" style={{width: '100%'}}/>
				<img className='mobile-block block-750-hiddle'  style={{width: '100%'}} src="https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17004638007264654.png" alt="" />
				<img className='block-750'  style={{width: '100%'}} src="https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17004638912513515.png" alt="" />
			</div>
			<div  className='app-content block-750'>
				<p  className='title'>{intl.formatMessage({id: 'home.app.title'})}</p>
				<p  className='content'>{intl.formatMessage({id: 'home.app.con'})}</p>
				<Link  className='more-btn' to='/InstallationVideo/app'>{intl.formatMessage({id: 'home.app.btn'})}</Link>
			</div>
		</div>
		<div className='scar-pro-wrapper home-brand'>
			{/* <div className='brand-img block-820'><img src={homePro5} alt="" /></div> */}
			<div className='home-brand-wrapper'>
				<div className='home-brand-title'>{intl.formatMessage({id: 'home.brand.title'})}</div>
				<p className='content'>{intl.formatMessage({id: 'home.brand.con'})}</p>
				<div className='brand-logo'><img src={brandLogo} alt="" /></div>
			</div>
			{/* <div className='brand-img block-820-hiddle'><img src={homePro5} alt="" /></div> */}
		</div>
		<div className='scar-pro-wrapper home-news'>
			<Link className='news-title' to="/News">{intl.formatMessage({id: 'home.news.title'})}</Link>
			<div className='news-list'>
				{newsList.map((item:any, index) => <div key={index} className='news-item'>
					<div><img src={item.newsImage} alt="" /></div>
					<div className={curNews === index ? newsLinkClass : 'link-btn'} onMouseMove={() => {setCurNews(index);setNewsLinkClass('link-btn moveIn');}} onMouseLeave={() => {setNewsLinkClass('link-btn moveOut')}} onClick={() => {
                if (!item.detail || item.detail === '') {return}
                window.open(`#/newsDetail/${item.newsId}`)
            }}>
						<p className='news-item-title'>{item.name}</p>
					</div>
					{/* <p className='font-16'>17 April 2022</p>
					<Link className='font-20 link-btn' to={'/News'}>{intl.formatMessage({id: 'home.news.btn'})}</Link> */}
				</div>)}
			</div>			
		</div>
	</div>
}